import * as tslib_1 from "tslib";
import { State, Action, Store, Selector } from '@ngxs/store';
var category = 'Query';
var SetAvailableSpanTypes = /** @class */ (function () {
    function SetAvailableSpanTypes(spanTypes) {
        this.spanTypes = spanTypes;
    }
    SetAvailableSpanTypes.type = "[" + category + "] ChangeStatus";
    return SetAvailableSpanTypes;
}());
export { SetAvailableSpanTypes };
var SetSelectedSpanTypes = /** @class */ (function () {
    function SetSelectedSpanTypes(SelectedSpanType) {
        this.SelectedSpanType = SelectedSpanType;
    }
    SetSelectedSpanTypes.type = "[" + category + "] SetSelectedSpanTypes";
    return SetSelectedSpanTypes;
}());
export { SetSelectedSpanTypes };
var QueryState = /** @class */ (function () {
    function QueryState(store) {
        this.store = store;
    }
    QueryState_1 = QueryState;
    // available spans state
    QueryState.availableSpanTypes = function (state) {
        return state.availableSpanTypes;
    };
    QueryState.prototype.setAvailableSpanTypes = function (ctx, action) {
        ctx.patchState({
            availableSpanTypes: action.spanTypes,
        });
    };
    // selected spans state
    QueryState.selectedSpanTypes = function (state) {
        return state.selectedSpanTypes;
    };
    QueryState.prototype.setSelectedSpanTypes = function (ctx, action) {
        ctx.patchState({
            selectedSpanTypes: action.SelectedSpanType,
        });
    };
    QueryState.prototype.getAvailableSpanTypes = function () {
        return this.store.selectSnapshot(QueryState_1.availableSpanTypes);
    };
    QueryState.prototype.getSelectedSpanTypes = function () {
        return this.store.selectSnapshot(QueryState_1.selectedSpanTypes);
    };
    var QueryState_1;
    tslib_1.__decorate([
        Action(SetAvailableSpanTypes),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object, SetAvailableSpanTypes]),
        tslib_1.__metadata("design:returntype", void 0)
    ], QueryState.prototype, "setAvailableSpanTypes", null);
    tslib_1.__decorate([
        Action(SetSelectedSpanTypes),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object, SetSelectedSpanTypes]),
        tslib_1.__metadata("design:returntype", void 0)
    ], QueryState.prototype, "setSelectedSpanTypes", null);
    tslib_1.__decorate([
        Selector([QueryState_1]),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], QueryState, "availableSpanTypes", null);
    tslib_1.__decorate([
        Selector([QueryState_1]),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], QueryState, "selectedSpanTypes", null);
    QueryState = QueryState_1 = tslib_1.__decorate([
        State({
            name: 'query',
            defaults: {
                availableSpanTypes: [],
                selectedSpanTypes: ['ALL'],
            },
        }),
        tslib_1.__metadata("design:paramtypes", [Store])
    ], QueryState);
    return QueryState;
}());
export { QueryState };
